// src/pages/SheGpt.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { SheGptSearch } from '../components';

const SheGpt: React.FC = () => {
  const navigate = useNavigate();
  const { userProfile, logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Erro ao fazer logout:', error);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-she flex flex-col">
      {/* Header */}
      <header className="bg-white shadow-md border-b border-she-palido-300">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-4">
              <button
                onClick={() => navigate('/')}
                className="w-12 h-11 flex items-center justify-center hover:opacity-80 transition-opacity"
                title="Voltar à página inicial"
              >
                {/* Logo SHE SVG */}
                <svg
                  className="w-full h-full"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 453.9 428.6"
                >
                  <g>
                    <path
                      fill="#8e162e"
                      d="M267,67.3c2.5,3.2,5.8,5.7,9.5,7.1,31.4,12.3,57.6,35,74.5,63.7,1.6,2.7,4.4,4.4,7.5,4.4h0c6.7,0,10.9-7.3,7.5-13.1-22.8-38.6-60.5-67.3-105.2-78.1-2.6-.6-4.5,2.4-2.9,4.4l9,11.5Z"
                    />
                    <path
                      fill="#8e162e"
                      d="M176.3,360.6c-2.1-2.7-4.9-4.6-8.1-5.9-29.6-11.3-54.8-31.7-72-57.8-1.6-2.5-4.4-4-7.3-4h0c-6.9,0-11.1,7.6-7.3,13.4,23.2,35.2,59.3,61.2,101.6,71.2s4.5-2.4,2.9-4.5l-9.7-12.4Z"
                    />
                    <path
                      fill="#8e162e"
                      d="M347,296.9c-17.7,26.8-43.7,47.6-74.4,58.7-1.1.4-2,1.1-2.7,2l-11.9,15.2c-1.6,2.1.3,5.1,2.9,4.4,41.9-10.1,77.7-36,100.8-71,3.8-5.7-.5-13.4-7.3-13.4h0c-3,0-5.7,1.5-7.3,4Z"
                    />
                    <path
                      fill="#8e162e"
                      d="M92.2,138.1c17.1-28.9,43.6-51.7,75.3-64,3.8-1.5,7.1-4,9.6-7.2l8.9-11.4c1.6-2.1-.3-5.1-2.9-4.5-45.1,10.6-83.1,39.5-106,78.3-3.4,5.8.8,13.1,7.5,13.1h0c3.1,0,5.9-1.7,7.5-4.4Z"
                    />
                  </g>
                  <g>
                    <path
                      fill="#bd274a"
                      d="M223.8,178.9l74.9-48.2-50-64.1-15.1-19.4-1.3-1.7c-2.6-3.3-6.4-5-10.3-5-3.8,0-7.6,1.7-10.2,5l-1.3,1.6-15.1,19.3-50.7,64.7,74.3,47.8c1.5,1,3.4,1,4.9,0Z"
                    />
                    <path
                      fill="#bd274a"
                      d="M417.7,212.1l-31.7-30.9-20.3-19.8c-1.2-1.2-2.7-1.9-4.3-2.1-.4,0-.7-.1-1.1-.1-2.1,0-4.2.9-5.8,2.6l-16.8,19-32.1-41.1-69.7,60c-1.3,1.1-2.2,2.6-2.3,4.3l-8.5,109.6c-.1,1.8-1.7,3.3-3.5,3.3s-3.4-1.4-3.5-3.3l-9.1-109.7c-.1-1.7-1-3.3-2.3-4.3l-69.1-59.6-32,40.8-16.9-19.1c-1.5-1.7-3.6-2.6-5.8-2.6-.4,0-.8,0-1.1.1-1.5.2-3,.9-4.2,2.1l-20.3,19.8-31.7,30.9c-3.1,3-3.1,8,0,11l33.6,32.7,18.4,18c1.5,1.5,3.4,2.2,5.4,2.2s1.1,0,1.6-.2c1.6-.3,3-1.1,4.2-2.4l19.6-22.2,102.1,130.3,1.3,1.6c2.6,3.3,6.4,5,10.2,5s7.7-1.7,10.3-5l1.3-1.7,101.5-130.2,19.5,22c1.1,1.3,2.6,2.1,4.1,2.4.5.1,1.1.2,1.6.2,1.9,0,3.9-.7,5.4-2.2l18.4-17.9,33.6-32.8c3.1-3,3.1-8,0-11Z"
                    />
                  </g>
                </svg>
              </button>
              <div>
                <h1 className="text-2xl font-bold text-she-venoso-900">
                  SHE GPT
                </h1>
                <p className="text-sm text-gray-600">
                  Assistente de IA para Análise Cardiovascular
                </p>
              </div>
            </div>

            <div className="flex items-center gap-4">
              {userProfile && (
                <div className="text-right">
                  <p className="text-sm font-medium text-she-venoso-900">
                    {userProfile.displayName || userProfile.email}
                  </p>
                  <span className="text-xs px-2 py-0.5 bg-she-palido-400 text-she-venoso-700 rounded-full font-medium">
                    {userProfile.role}
                  </span>
                </div>
              )}

              <button
                onClick={handleLogout}
                className="px-4 py-2 bg-she-palido-300 text-she-venoso-700 rounded-lg hover:bg-she-palido-400 transition text-sm font-medium flex items-center gap-2"
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                </svg>
                Sair
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Conteúdo principal */}
      <div className="flex-1 flex flex-col justify-start items-center text-center max-w-4xl mx-auto px-4 sm:px-6 py-8">
        {/* Descrição */}
        <div className="mb-8">
          <p className="text-lg text-gray-700 max-w-2xl">
            Assistente virtual para consulta e suporte em cardiologia estrutural. Faça perguntas sobre procedimentos, diagnósticos e condutas.
          </p>
        </div>

        {/* Componente da SHE GPT */}
        <div className="w-full">
          <SheGptSearch />
        </div>
      </div>
    </div>
  );
};

export default SheGpt;
